export default class Register {

  constructor(name) {
    window[name] = this.data();
  }

  data() {
    return {
      errorMessage: null,
      globalErrorMessage: null,
      dashboardUrl: null,
      loadingAddres: false,
      loading: false,
      formField: {
        jouw_naam_hier: null,
        gender: null,
        first_name: null,
        name_insertion: null,
        last_name: null,
        email: null,
        termsOfUse: null,
        project_opt_in: null,
        privacy_declaration: null,
        country: "NL",
        number_addition: null,
        tags: []
      },
      Register(vm = this) {
        var xhttp = new XMLHttpRequest();
        vm.loading = true;
        vm.globalErrorMessage = null;
        xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            vm.loading = false;
            var response = JSON.parse(this.responseText);
            if (typeof (response.error) !== "undefined") {
              vm.errorMessage = response.error;
              return false;
            }
            if (typeof (response.validation) !== "undefined") {
              vm.ValidationResponse(response.validation);
              return false;
            }

            window.dataLayer.push({
              "event": "account_register",
              ...vm.pushAdditionalQuestionsDataLayer()
            });

            // redirect to location
            window.parent.parent.window.location = "/account/" + response.data.createUncompletedAccount.uid + "/bedankt-inschrijving/";
          }

          if (this.readyState === 4 && this.status === 429) {
            var response = JSON.parse(this.responseText);
            vm.globalErrorMessage = response.error;
          }

          vm.loading = false;
        };
        xhttp.open("post", "/woonmens/api/register", true);

        xhttp.setRequestHeader("Content-type", "application/json;charset=utf-8");
        xhttp.send(JSON.stringify(this.formField));
      },
      pushAdditionalQuestionsDataLayer() {
        let tags = [];
        const additionalQuestions = document.getElementsByClassName("additional_questions");

        for (const additionalQuestion of additionalQuestions) {
          const text = additionalQuestion.textContent.trim();

          for (const additionalQuestionChild of additionalQuestion.children) {
            if (additionalQuestionChild.type === "checkbox" && additionalQuestionChild.checked === true) {
              tags[additionalQuestionChild.value.toString()] = text;
            }
          }
        }

        return tags;
      },
      CheckEmail() {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.formField.email).toLowerCase());
      },

      hasZipAndNumberValues() {
        if (!this.formField.zip || !this.formField.number) return false;
        return true;
      },

      CheckAddress() {
        var vm = this;
        if (!vm.hasZipAndNumberValues()) return;


        vm.loadingAddres = true;

        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            var response = JSON.parse(this.responseText);
            if (response.street != null && response.street.toLowerCase() === "postbus") {
              var el = document.querySelector("[name=\"account_details.zip\"]");
              vm.makeErrorDiv(el, "Postbus niet toegestaan");
              vm.loadingAddres = false;
              return false;
            }
            vm.formField.street = response.street;
            vm.formField.city = response.city;
            vm.loadingAddres = false;
          }
        };
        xhttp.open("post", "/woonmens/api/get-address", true);
        xhttp.setRequestHeader("Content-type", "application/json;charset=utf-8");
        xhttp.send(JSON.stringify(this.formField));
      },


      ValidationResponse(ValidationResponse) {
        var vm = this;
        document.querySelectorAll(".has-errors").forEach(el => el.classList.remove("has-errors"));
        document.querySelectorAll(".woonmens-validation-message").forEach(el => el.remove());

        if (typeof (ValidationResponse) !== "undefined") {
          Object.keys(ValidationResponse).forEach(function(item) {
            var el = document.querySelector("[name=\"" + item + "\"]");
            if (el) {
              let value = 'Er ging iets fout';

              if (typeof ValidationResponse[item] === "string") {
                value = ValidationResponse[item];
              } else if (Array.isArray(ValidationResponse[item]) && ValidationResponse[item][0]) {
                value = ValidationResponse[item][0];
              }

              vm.makeErrorDiv(el, value);
            }
          });
        }

      },

      makeErrorDiv(el, message) {
        // if(el.type === 'radio'){
        // 	document.querySelectorAll('[name="' + el.name + '"]').forEach(el => {
        // 		el.nextSibling
        // 		var next = el.nextSibling
        // 		if( next ) next.classList.add('radio-error')
        // 		el.addEventListener('change', function() {
        // 			document.querySelectorAll('.radio-error').forEach(el => {
        // 				el.classList.remove('radio-error')
        // 			})
        // 		})
        // 	})
        // 	return
        // }

        el.parentNode.classList.add("has-errors");

        el.insertAdjacentHTML("afterend", "<div class=\"woonmens-validation-message text-xs text-red\"> " + message + " </div>");
        el.addEventListener("focus", function() {
          el.parentNode.classList.remove("has-errors");
          var next = el.nextSibling;
          if (next) next.remove();
        });
      }
    };
  }
}
